export const translations = {
  en: {
    nav: { home: "Home", about: "About", products: "Products", dealers: "Dealers", contact: "Contact", careers: "Careers" },
    hero: {
      tagline: "Chemistry that Cultivates",
      subtitle: "Innovative biostimulants and fertilizers for thriving farms across India",
      cta: "Explore Products",
      ctaSecondary: "Learn More"
    },
    aboutTeaser: {
      title: "Pioneering Agricultural Innovation",
      description: "Founded in 2024, Avantra Chemicals is revolutionizing Indian agriculture with Phytocode technology - stabilizing multiple nutrients in one formulation for longer viability and slow nutrient release.",
      phytocode: "Phytocode Technology"
    },
    phytocode: {
      title: "Phytocode Technology",
      intro: "Avantra Chemicals has pioneered Phytocode™ technology, a breakthrough innovation that masterfully integrates and stabilizes multiple essential nutrients within a single, advanced formulation.",
      benefit1Title: "Nutrient Synergy",
      benefit1Desc: "Encapsulates diverse macros, micros, and biostimulants without degradation, ensuring 2-3x longer stability.",
      benefit2Title: "Prolonged Efficacy",
      benefit2Desc: "Formulations remain potent for extended periods, reducing application frequency and waste.",
      benefit3Title: "Plant-Optimized Release",
      benefit3Desc: "Gradually meters nutrients at cellular level, minimizing leaching, boosting uptake by 20-30%, and enhancing stress resilience.",
      howItWorksTitle: "How It Works",
      howItWorksDesc: "Phytocode employs nano-encapsulation and bio-matrix chelation to lock nutrients in a protective lattice. Upon application, plant enzymes trigger timed release—fostering root vigor, bloom retention, and fruit quality without overload."
    },
    stats: {
      dealers: "50",
      farmers: "12K",
      acres: "100K",
      licenses: "25",
      team: "100",
      products: "15",
      states: "10"
    },
    products: {
      title: "Our Products",
      subtitle: "Comprehensive range of biostimulants, fertilizers, and micronutrients",
      all: "All",
      biostimulant: "Biostimulants",
      biofertilizer: "Biofertilizers",
      liquid_fertilizer: "Liquid Fertilizers",
      micronutrient: "Micronutrients",
      water_soluble: "Water Soluble",
      viewProduct: "View Details",
      featured: "Featured"
    },
    productDetail: {
      composition: "Composition",
      howItWorks: "How It Works",
      growthStages: "Targeted Growth Stages",
      dosage: "Dosage & Application",
      advantages: "Key Advantages",
      backToProducts: "Back to Products",
      component: "Component",
      specification: "Specification"
    },
    about: {
      title: "About Avantra Chemicals",
      subtitle: "Young agri-entrepreneurs building the future of Indian farming",
      mission: "Mission",
      missionText: "To empower Indian farmers with world-class, science-backed crop nutrition solutions that maximize yield, quality, and sustainability.",
      vision: "Vision",
      visionText: "To be India's most trusted agri-input brand, bridging the gap between cutting-edge research and farm-level impact.",
      values: "Our Values",
      valuesItems: ["Innovation through Science", "Farmer-First Approach", "Quality without Compromise", "Sustainable Agriculture"],
      timeline: "Our Journey",
      team: "Our Team",
      teamDesc: "Led by young agri-entrepreneurs with strong agriculture background, supported by 18+ dedicated team members.",
      advisory: "Advisory Board",
      advisoryDesc: "Guided by ex-scientists and professors from premier institutions.",
      advisoryMembers: ["Ex-Scientists from ICAR Delhi", "Professors from IIHR Bengaluru", "Faculty from GKVK Mysore"],
      phytocodeTitle: "Phytocode Technology",
      phytocodeDesc: "Our proprietary technology stabilizes multiple nutrients in a single formulation, ensuring longer viability and controlled slow nutrient release for maximum crop benefit.",
      addresses: "Our Locations",
      corporate: "Corporate Office",
      corporateAddr: "No.5, RKM Street, New Strt, Gupta Layout, Halasuru, Bengaluru - 560068",
      factory: "Factory",
      factoryAddr: "No.375, Lakshmipura, Srinivaspura, Kolar - 563135"
    },
    dealers: {
      title: "Dealer Network",
      subtitle: "70+ dealerships across Karnataka and Andhra Pradesh serving 12,000+ farmers",
      becomeDealer: "Become a Dealer",
      dealerForm: "Apply to become an Avantra dealer",
      name: "Full Name",
      businessName: "Business Name",
      email: "Email",
      phone: "Phone",
      location: "Location / City",
      message: "Why do you want to become an Avantra dealer?",
      submit: "Submit Application",
      mapTitle: "Our Presence",
      success: "Application submitted successfully!",
      states: "Active in Karnataka & Andhra Pradesh"
    },
    contact: {
      title: "Contact Us",
      subtitle: "Get in touch with our team for inquiries, support, or partnerships",
      name: "Your Name",
      email: "Email Address",
      phone: "Phone Number",
      message: "Your Message",
      submit: "Send Message",
      success: "Message sent successfully! We'll get back to you soon.",
      info: "Contact Information",
      corporate: "Corporate Office",
      factory: "Factory"
    },
    careers: {
      title: "Join Our Team",
      subtitle: "Build the future of Indian agriculture with us",
      openPositions: "Open Positions",
      noJobs: "No open positions at the moment. Check back soon!",
      applyNow: "Apply Now",
      viewDetails: "View Details",
      department: "Department",
      location: "Location",
      type: "Type",
      experience: "Experience",
      description: "Job Description",
      requirements: "Requirements",
      responsibilities: "Responsibilities",
      applicationForm: "Application Form",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Mobile Number",
      address: "Address",
      currentCompany: "Current Company",
      currentCTC: "Current CTC",
      photo: "Passport Size Photo",
      resume: "Resume (PDF)",
      payslip: "Current Payslip (optional)",
      submit: "Submit Application",
      success: "Application submitted successfully! We'll get back to you soon.",
      backToJobs: "Back to Careers"
    },
    testimonials: {
      title: "What Farmers Say",
      items: [
        { quote: "Amazing fruit size improvement with Avantra KMS. My pomegranate yield increased by 30% this season.", name: "Aadinarayana", crop: "Pomegranate Farmer", location: "Andhra Pradesh" },
        { quote: "Best results with Trumagic on my watermelon fields. The plants recovered from drought stress within days.", name: "Prabhakar", crop: "Watermelon Farmer", location: "Karnataka" },
        { quote: "50% more flowering after using Helia. My mango trees have never looked better. Highly recommended!", name: "Subba Reddy", crop: "Mango Farmer", location: "Andhra Pradesh" }
      ]
    },
    footer: {
      description: "Leading manufacturer of biostimulants, fertilizers, and micronutrients. Chemistry that Cultivates.",
      quickLinks: "Quick Links",
      productCategories: "Products",
      contactInfo: "Contact Info",
      followUs: "Follow Us",
      copyright: "2026 Avantra Chemicals Pvt Ltd. All rights reserved.",
      tagline: "Grow . Thrive . Yield",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      corporate: "Corporate Info"
    },
    common: { learnMore: "Learn More", submit: "Submit", loading: "Loading...", success: "Success!", error: "Something went wrong", search: "Search products..." }
  },
  te: {
    nav: { home: "హోమ్", about: "మా గురించి", products: "ఉత్పత్తులు", dealers: "డీలర్లు", contact: "సంప్రదించండి", careers: "ఉద్యోగాలు" },
    hero: {
      tagline: "సేద్యం చేసే రసాయన శాస్త్రం",
      subtitle: "భారతదేశం అంతటా వర్ధిల్లుతున్న పొలాల కోసం వినూత్న బయోస్టిమ్యులెంట్లు మరియు ఎరువులు",
      cta: "ఉత్పత్తులు చూడండి",
      ctaSecondary: "మరింత తెలుసుకోండి"
    },
    aboutTeaser: {
      title: "వ్యవసాయ ఆవిష్కరణలో అగ్రగామి",
      description: "2024లో స్థాపించబడిన అవంత్ర కెమికల్స్ ఫైటోకోడ్ టెక్నాలజీతో భారత వ్యవసాయాన్ని విప్లవాత్మకం చేస్తోంది.",
      phytocode: "ఫైటోకోడ్ టెక్నాలజీ"
    },
    phytocode: {
      title: "ఫైటోకోడ్ టెక్నాలజీ",
      intro: "అవంత్ర కెమికల్స్ ఫైటోకోడ్™ టెక్నాలజీని అభివృద్ధి చేసింది - ఒకే అధునాతన ఫార్ములేషన్‌లో బహుళ అవసరమైన పోషకాలను సమగ్రపరచి స్థిరీకరించే ప్రగతిశీల ఆవిష్కరణ.",
      benefit1Title: "పోషక సమన్వయం",
      benefit1Desc: "మాక్రోస్, మైక్రోస్ మరియు బయోస్టిమ్యులెంట్లను క్షీణత లేకుండా ఎన్‌క్యాప్సులేట్ చేయడం, 2-3 రెట్లు ఎక్కువ స్థిరత్వం.",
      benefit2Title: "దీర్ఘకాల ప్రభావం",
      benefit2Desc: "ఫార్ములేషన్లు ఎక్కువ కాలం శక్తివంతంగా ఉంటాయి, అప్లికేషన్ ఫ్రీక్వెన్సీ మరియు వృధాను తగ్గిస్తాయి.",
      benefit3Title: "మొక్కకు అనుకూల విడుదల",
      benefit3Desc: "సెల్యులార్ స్థాయిలో క్రమంగా పోషకాలను అందిస్తుంది, లీచింగ్‌ను తగ్గించి, 20-30% ఎక్కువ శోషణ.",
      howItWorksTitle: "ఇది ఎలా పనిచేస్తుంది",
      howItWorksDesc: "ఫైటోకోడ్ నానో-ఎన్‌క్యాప్సులేషన్ మరియు బయో-మ్యాట్రిక్స్ చీలేషన్ ఉపయోగించి పోషకాలను రక్షణాత్మక జాలకంలో లాక్ చేస్తుంది. అప్లికేషన్ తర్వాత, మొక్కల ఎంజైమ్‌లు సమయానుకూల విడుదలను ప్రేరేపిస్తాయి."
    },
    stats: { dealers: "డీలర్‌షిప్‌లు", farmers: "సేవించిన రైతులు", acres: "కవర్ చేసిన ఎకరాలు", licenses: "లైసెన్స్డ్ ఉత్పత్తులు", team: "టీమ్ సభ్యులు", products: "ఉత్పత్తి శ్రేణి" },
    products: {
      title: "మా ఉత్పత్తులు",
      subtitle: "బయోస్టిమ్యులెంట్లు, ఎరువులు మరియు సూక్ష్మ పోషకాల సమగ్ర శ్రేణి",
      all: "అన్ని",
      biostimulant: "బయోస్టిమ్యులెంట్లు",
      biofertilizer: "బయోఫెర్టిలైజర్లు",
      liquid_fertilizer: "లిక్విడ్ ఎరువులు",
      micronutrient: "సూక్ష్మ పోషకాలు",
      water_soluble: "నీటిలో కరిగే",
      viewProduct: "వివరాలు చూడండి",
      featured: "ఫీచర్డ్"
    },
    productDetail: { composition: "సంయోజన", howItWorks: "ఇది ఎలా పనిచేస్తుంది", growthStages: "వృద్ధి దశలు", dosage: "మోతాదు & అప్లికేషన్", advantages: "ముఖ్య ప్రయోజనాలు", backToProducts: "ఉత్పత్తులకు తిరిగి", component: "భాగం", specification: "స్పెసిఫికేషన్" },
    about: {
      title: "అవంత్ర కెమికల్స్ గురించి",
      subtitle: "భారత వ్యవసాయ భవిష్యత్తును నిర్మిస్తున్న యువ వ్యవసాయ వ్యాపారవేత్తలు",
      mission: "మిషన్", missionText: "దిగుబడి, నాణ్యత మరియు సుస్థిరతను గరిష్టం చేసే విశ్వస్థాయి పంట పోషణ పరిష్కారాలతో భారత రైతులను సాధికారం చేయడం.",
      vision: "విజన్", visionText: "అత్యాధునిక పరిశోధన మరియు పొలం-స్థాయి ప్రభావం మధ్య అంతరాన్ని తగ్గించడం.",
      values: "మా విలువలు", valuesItems: ["శాస్త్రం ద్వారా ఆవిష్కరణ", "రైతు-ప్రథమ విధానం", "నాణ్యతలో రాజీలేకుండా", "సుస్థిర వ్యవసాయం"],
      timeline: "మా ప్రయాణం", team: "మా టీమ్", teamDesc: "18+ అంకితమైన సభ్యులతో బలమైన వ్యవసాయ నేపథ్యం ఉన్న యువ వ్యవసాయ వ్యాపారవేత్తలు నేతృత్వం.",
      advisory: "సలహా మండలి", advisoryDesc: "ప్రముఖ సంస్థల నుండి మాజీ శాస్త్రవేత్తలు మరియు ప్రొఫెసర్లు.",
      advisoryMembers: ["ICAR ఢిల్లీ మాజీ శాస్త్రవేత్తలు", "IIHR బెంగళూరు ప్రొఫెసర్లు", "GKVK మైసూర్ అధ్యాపకులు"],
      phytocodeTitle: "ఫైటోకోడ్ టెక్నాలజీ", phytocodeDesc: "మా స్వంత టెక్నాలజీ ఒకే ఫార్ములేషన్‌లో బహుళ పోషకాలను స్థిరీకరిస్తుంది.",
      addresses: "మా స్థానాలు", corporate: "కార్పొరేట్ ఆఫీస్", corporateAddr: "నం.5, RKM స్ట్రీట్, హలసూరు, బెంగళూరు - 560068", factory: "ఫ్యాక్టరీ", factoryAddr: "నం.375, లక్ష్మీపుర, శ్రీనివాసపుర, కోలార్ - 563135"
    },
    dealers: { title: "డీలర్ నెట్‌వర్క్", subtitle: "కర్ణాటక మరియు ఆంధ్రప్రదేశ్‌లో 70+ డీలర్‌షిప్‌లు 12,000+ రైతులకు సేవ", becomeDealer: "డీలర్ అవ్వండి", dealerForm: "అవంత్ర డీలర్ అవ్వడానికి దరఖాస్తు చేయండి", name: "పూర్తి పేరు", businessName: "వ్యాపార పేరు", email: "ఇమెయిల్", phone: "ఫోన్", location: "స్థానం / నగరం", message: "మీరు అవంత్ర డీలర్ ఎందుకు అవ్వాలనుకుంటున్నారు?", submit: "దరఖాస్తు సమర్పించండి", mapTitle: "మా ఉనికి", success: "దరఖాస్తు విజయవంతంగా సమర్పించబడింది!", states: "కర్ణాటక & ఆంధ్రప్రదేశ్‌లో సక్రియం" },
    contact: { title: "మమ్మల్ని సంప్రదించండి", subtitle: "విచారణలు, మద్దతు లేదా భాగస్వామ్యం కోసం మా టీమ్‌ని సంప్రదించండి", name: "మీ పేరు", email: "ఇమెయిల్ చిరునామా", phone: "ఫోన్ నంబర్", message: "మీ సందేశం", submit: "సందేశం పంపండి", success: "సందేశం విజయవంతంగా పంపబడింది!", info: "సంప్రదింపు సమాచారం", corporate: "కార్పొరేట్ ఆఫీస్", factory: "ఫ్యాక్టరీ" },
    testimonials: {
      title: "రైతులు ఏమంటున్నారు",
      items: [
        { quote: "అవంత్ర KMSతో అద్భుతమైన పండు పరిమాణం. నా దానిమ్మ దిగుబడి 30% పెరిగింది.", name: "ఆదినారాయణ", crop: "దానిమ్మ రైతు", location: "ఆంధ్రప్రదేశ్" },
        { quote: "Trumagicతో నా పుచ్చకాయ పొలాల్లో అత్యుత్తమ ఫలితాలు. కరువు నుండి త్వరగా కోలుకున్నాయి.", name: "ప్రభాకర్", crop: "పుచ్చకాయ రైతు", location: "కర్ణాటక" },
        { quote: "Helia ఉపయోగించిన తర్వాత 50% ఎక్కువ పూలు. నా మామిడి చెట్లు చాలా బాగున్నాయి.", name: "సుబ్బారెడ్డి", crop: "మామిడి రైతు", location: "ఆంధ్రప్రదేశ్" }
      ]
    },
    footer: { description: "బయోస్టిమ్యులెంట్లు, ఎరువులు మరియు సూక్ష్మ పోషకాల ప్రముఖ తయారీదారు.", quickLinks: "త్వరిత లింకులు", productCategories: "ఉత్పత్తులు", contactInfo: "సంప్రదింపు సమాచారం", followUs: "మమ్మల్ని అనుసరించండి", copyright: "2026 అవంత్ర కెమికల్స్ ప్రైవేట్ లిమిటెడ్. అన్ని హక్కులు రక్షించబడ్డాయి.", tagline: "పెరగండి . వర్ధిల్లండి . దిగుబడి" },
    common: { learnMore: "మరింత తెలుసుకోండి", submit: "సమర్పించండి", loading: "లోడ్ అవుతోంది...", success: "విజయం!", error: "ఏదో తప్పు జరిగింది", search: "ఉత్పత్తులు శోధించండి..." }
  },
  kn: {
    nav: { home: "ಹೋಮ್", about: "ನಮ್ಮ ಬಗ್ಗೆ", products: "ಉತ್ಪನ್ನಗಳು", dealers: "ಡೀಲರ್‌ಗಳು", contact: "ಸಂಪರ್ಕಿಸಿ", careers: "ಉದ್ಯೋಗಗಳು" },
    hero: {
      tagline: "ಬೆಳೆಸುವ ರಸಾಯನಶಾಸ್ತ್ರ",
      subtitle: "ಭಾರತದಾದ್ಯಂತ ಸಮೃದ್ಧ ಕೃಷಿಗಾಗಿ ನವೀನ ಬಯೋಸ್ಟಿಮ್ಯುಲೆಂಟ್‌ಗಳು ಮತ್ತು ರಸಗೊಬ್ಬರಗಳು",
      cta: "ಉತ್ಪನ್ನಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
      ctaSecondary: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ"
    },
    aboutTeaser: {
      title: "ಕೃಷಿ ಆವಿಷ್ಕಾರದಲ್ಲಿ ಮುಂಚೂಣಿ",
      description: "2024ರಲ್ಲಿ ಸ್ಥಾಪಿಸಲಾದ ಅವಂತ್ರ ಕೆಮಿಕಲ್ಸ್ ಫೈಟೋಕೋಡ್ ತಂತ್ರಜ್ಞಾನದಿಂದ ಭಾರತೀಯ ಕೃಷಿಯಲ್ಲಿ ಕ್ರಾಂತಿ ತರುತ್ತಿದೆ.",
      phytocode: "ಫೈಟೋಕೋಡ್ ತಂತ್ರಜ್ಞಾನ"
    },
    phytocode: {
      title: "ಫೈಟೋಕೋಡ್ ತಂತ್ರಜ್ಞಾನ",
      intro: "ಅವಂತ್ರ ಕೆಮಿಕಲ್ಸ್ ಫೈಟೋಕೋಡ್™ ತಂತ್ರಜ್ಞಾನವನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಿದೆ - ಒಂದೇ ಸುಧಾರಿತ ಫಾರ್ಮುಲೇಶನ್‌ನಲ್ಲಿ ಬಹು ಅಗತ್ಯ ಪೋಷಕಗಳನ್ನು ಸಮಗ್ರಗೊಳಿಸಿ ಸ್ಥಿರಗೊಳಿಸುವ ಪ್ರಗತಿಶೀಲ ಆವಿಷ್ಕಾರ.",
      benefit1Title: "ಪೋಷಕ ಸಿನರ್ಜಿ",
      benefit1Desc: "ಮ್ಯಾಕ್ರೋಸ್, ಮೈಕ್ರೋಸ್ ಮತ್ತು ಬಯೋಸ್ಟಿಮ್ಯುಲೆಂಟ್‌ಗಳನ್ನು ಕ್ಷೀಣತೆಯಿಲ್ಲದೆ ಎನ್‌ಕ್ಯಾಪ್ಸುಲೇಟ್ ಮಾಡುವುದು, 2-3 ಪಟ್ಟು ಹೆಚ್ಚು ಸ್ಥಿರತೆ.",
      benefit2Title: "ದೀರ್ಘಕಾಲದ ಪರಿಣಾಮ",
      benefit2Desc: "ಫಾರ್ಮುಲೇಶನ್‌ಗಳು ದೀರ್ಘಾವಧಿಯವರೆಗೆ ಪ್ರಬಲವಾಗಿರುತ್ತವೆ, ಅನ್ವಯಿಕೆಯ ಆವರ್ತನ ಮತ್ತು ವ್ಯರ್ಥವನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತವೆ.",
      benefit3Title: "ಸಸ್ಯ-ಅನುಕೂಲಿತ ಬಿಡುಗಡೆ",
      benefit3Desc: "ಸೆಲ್ಯುಲಾರ್ ಮಟ್ಟದಲ್ಲಿ ಕ್ರಮೇಣ ಪೋಷಕಗಳನ್ನು ನೀಡುತ್ತದೆ, ಲೀಚಿಂಗ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡಿ, 20-30% ಹೆಚ್ಚು ಹೀರಿಕೊಳ್ಳುವಿಕೆ.",
      howItWorksTitle: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      howItWorksDesc: "ಫೈಟೋಕೋಡ್ ನ್ಯಾನೋ-ಎನ್‌ಕ್ಯಾಪ್ಸುಲೇಶನ್ ಮತ್ತು ಬಯೋ-ಮ್ಯಾಟ್ರಿಕ್ಸ್ ಚೀಲೇಶನ್ ಬಳಸಿ ಪೋಷಕಗಳನ್ನು ರಕ್ಷಣಾತ್ಮಕ ಜಾಲದಲ್ಲಿ ಲಾಕ್ ಮಾಡುತ್ತದೆ. ಅನ್ವಯದ ನಂತರ, ಸಸ್ಯ ಕಿಣ್ವಗಳು ಸಮಯಬದ್ಧ ಬಿಡುಗಡೆಯನ್ನು ಪ್ರಚೋದಿಸುತ್ತವೆ."
    },
    stats: { dealers: "ಡೀಲರ್‌ಶಿಪ್‌ಗಳು", farmers: "ಸೇವಿಸಿದ ರೈತರು", acres: "ಎಕರೆಗಳು", licenses: "ಲೈಸೆನ್ಸ್ ಉತ್ಪನ್ನಗಳು", team: "ತಂಡ ಸದಸ್ಯರು", products: "ಉತ್ಪನ್ನ ಶ್ರೇಣಿ" },
    products: {
      title: "ನಮ್ಮ ಉತ್ಪನ್ನಗಳು",
      subtitle: "ಬಯೋಸ್ಟಿಮ್ಯುಲೆಂಟ್‌ಗಳು, ರಸಗೊಬ್ಬರಗಳು ಮತ್ತು ಸೂಕ್ಷ್ಮ ಪೋಷಕಗಳ ಸಮಗ್ರ ಶ್ರೇಣಿ",
      all: "ಎಲ್ಲಾ", biostimulant: "ಬಯೋಸ್ಟಿಮ್ಯುಲೆಂಟ್‌ಗಳು", biofertilizer: "ಬಯೋಫರ್ಟಿಲೈಸರ್‌ಗಳು", liquid_fertilizer: "ದ್ರವ ರಸಗೊಬ್ಬರಗಳು", micronutrient: "ಸೂಕ್ಷ್ಮ ಪೋಷಕಗಳು", water_soluble: "ನೀರು ಕರಗುವ",
      viewProduct: "ವಿವರಗಳನ್ನು ನೋಡಿ", featured: "ವೈಶಿಷ್ಟ್ಯ"
    },
    productDetail: { composition: "ಸಂಯೋಜನೆ", howItWorks: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ", growthStages: "ಗುರಿ ವೃದ್ಧಿ ಹಂತಗಳು", dosage: "ಪ್ರಮಾಣ & ಅನ್ವಯ", advantages: "ಮುಖ್ಯ ಲಾಭಗಳು", backToProducts: "ಉತ್ಪನ್ನಗಳಿಗೆ ಹಿಂತಿರುಗಿ", component: "ಘಟಕ", specification: "ನಿರ್ದಿಷ್ಟೀಕರಣ" },
    about: {
      title: "ಅವಂತ್ರ ಕೆಮಿಕಲ್ಸ್ ಬಗ್ಗೆ", subtitle: "ಭಾರತೀಯ ಕೃಷಿಯ ಭವಿಷ್ಯವನ್ನು ನಿರ್ಮಿಸುತ್ತಿರುವ ಯುವ ಕೃಷಿ ಉದ್ಯಮಿಗಳು",
      mission: "ಮಿಷನ್", missionText: "ಇಳುವೈ, ಗುಣಮಟ್ಟ ಮತ್ತು ಸುಸ್ಥಿರತೆಯನ್ನು ಗರಿಷ್ಠಗೊಳಿಸುವ ವಿಶ್ವದರ್ಜೆಯ ಬೆಳೆ ಪೋಷಣೆ ಪರಿಹಾರಗಳೊಂದಿಗೆ ಭಾರತೀಯ ರೈತರನ್ನು ಸಶಕ್ತಗೊಳಿಸುವುದು.",
      vision: "ವಿಜನ್", visionText: "ಅತ್ಯಾಧುನಿಕ ಸಂಶೋಧನೆ ಮತ್ತು ಕೃಷಿ-ಮಟ್ಟದ ಪರಿಣಾಮದ ನಡುವಿನ ಅಂತರವನ್ನು ಕಡಿಮೆ ಮಾಡುವುದು.",
      values: "ನಮ್ಮ ಮೌಲ್ಯಗಳು", valuesItems: ["ವಿಜ್ಞಾನದ ಮೂಲಕ ಆವಿಷ್ಕಾರ", "ರೈತ-ಮೊದಲ ವಿಧಾನ", "ಗುಣಮಟ್ಟದಲ್ಲಿ ರಾಜಿಯಿಲ್ಲ", "ಸುಸ್ಥಿರ ಕೃಷಿ"],
      timeline: "ನಮ್ಮ ಪ್ರಯಾಣ", team: "ನಮ್ಮ ತಂಡ", teamDesc: "18+ ಸಮರ್ಪಿತ ಸದಸ್ಯರೊಂದಿಗೆ ಬಲವಾದ ಕೃಷಿ ಹಿನ್ನೆಲೆಯ ಯುವ ಕೃಷಿ ಉದ್ಯಮಿಗಳ ನೇತೃತ್ವ.",
      advisory: "ಸಲಹಾ ಮಂಡಳಿ", advisoryDesc: "ಪ್ರಮುಖ ಸಂಸ್ಥೆಗಳ ಮಾಜಿ ವಿಜ್ಞಾನಿಗಳು ಮತ್ತು ಪ್ರಾಧ್ಯಾಪಕರು.",
      advisoryMembers: ["ICAR ದೆಹಲಿ ಮಾಜಿ ವಿಜ್ಞಾನಿಗಳು", "IIHR ಬೆಂಗಳೂರು ಪ್ರಾಧ್ಯಾಪಕರು", "GKVK ಮೈಸೂರು ಅಧ್ಯಾಪಕರು"],
      phytocodeTitle: "ಫೈಟೋಕೋಡ್ ತಂತ್ರಜ್ಞಾನ", phytocodeDesc: "ನಮ್ಮ ಸ್ವಂತ ತಂತ್ರಜ್ಞಾನ ಒಂದೇ ಫಾರ್ಮುಲೇಶನ್‌ನಲ್ಲಿ ಬಹು ಪೋಷಕಗಳನ್ನು ಸ್ಥಿರಗೊಳಿಸುತ್ತದೆ.",
      addresses: "ನಮ್ಮ ಸ್ಥಳಗಳು", corporate: "ಕಾರ್ಪೊರೇಟ್ ಕಛೇರಿ", corporateAddr: "ನಂ.5, RKM ಸ್ಟ್ರೀಟ್, ಹಲಸೂರು, ಬೆಂಗಳೂರು - 560068", factory: "ಕಾರ್ಖಾನೆ", factoryAddr: "ನಂ.375, ಲಕ್ಷ್ಮೀಪುರ, ಶ್ರೀನಿವಾಸಪುರ, ಕೋಲಾರ - 563135"
    },
    dealers: { title: "ಡೀಲರ್ ನೆಟ್‌ವರ್ಕ್", subtitle: "ಕರ್ನಾಟಕ ಮತ್ತು ಆಂಧ್ರಪ್ರದೇಶದಲ್ಲಿ 70+ ಡೀಲರ್‌ಶಿಪ್‌ಗಳು 12,000+ ರೈತರಿಗೆ ಸೇವೆ", becomeDealer: "ಡೀಲರ್ ಆಗಿ", dealerForm: "ಅವಂತ್ರ ಡೀಲರ್ ಆಗಲು ಅರ್ಜಿ", name: "ಪೂರ್ಣ ಹೆಸರು", businessName: "ವ್ಯಾಪಾರ ಹೆಸರು", email: "ಇಮೇಲ್", phone: "ಫೋನ್", location: "ಸ್ಥಳ / ನಗರ", message: "ನೀವು ಅವಂತ್ರ ಡೀಲರ್ ಏಕೆ ಆಗಬೇಕೆಂದಿದ್ದೀರಿ?", submit: "ಅರ್ಜಿ ಸಲ್ಲಿಸಿ", mapTitle: "ನಮ್ಮ ಉಪಸ್ಥಿತಿ", success: "ಅರ್ಜಿ ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!", states: "ಕರ್ನಾಟಕ & ಆಂಧ್ರಪ್ರದೇಶದಲ್ಲಿ ಸಕ್ರಿಯ" },
    contact: { title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ", subtitle: "ವಿಚಾರಣೆ, ಬೆಂಬಲ ಅಥವಾ ಸಹಭಾಗಿತ್ವಕ್ಕಾಗಿ ನಮ್ಮ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ", name: "ನಿಮ್ಮ ಹೆಸರು", email: "ಇಮೇಲ್ ವಿಳಾಸ", phone: "ಫೋನ್ ಸಂಖ್ಯೆ", message: "ನಿಮ್ಮ ಸಂದೇಶ", submit: "ಸಂದೇಶ ಕಳುಹಿಸಿ", success: "ಸಂದೇಶ ಯಶಸ್ವಿಯಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ!", info: "ಸಂಪರ್ಕ ಮಾಹಿತಿ", corporate: "ಕಾರ್ಪೊರೇಟ್ ಕಛೇರಿ", factory: "ಕಾರ್ಖಾನೆ" },
    testimonials: {
      title: "ರೈತರು ಏನು ಹೇಳುತ್ತಾರೆ",
      items: [
        { quote: "ಅವಂತ್ರ KMS ನಿಂದ ಅದ್ಭುತ ಫಲದ ಗಾತ್ರ ಸುಧಾರಣೆ. ನನ್ನ ದಾಳಿಂಬೆ ಇಳುವೈ 30% ಹೆಚ್ಚಾಯಿತು.", name: "ಆದಿನಾರಾಯಣ", crop: "ದಾಳಿಂಬೆ ರೈತ", location: "ಆಂಧ್ರಪ್ರದೇಶ" },
        { quote: "Trumagic ನೊಂದಿಗೆ ನನ್ನ ಕಲ್ಲಂಗಡಿ ಹೊಲಗಳಲ್ಲಿ ಅತ್ಯುತ್ತಮ ಫಲಿತಾಂಶಗಳು.", name: "ಪ್ರಭಾಕರ್", crop: "ಕಲ್ಲಂಗಡಿ ರೈತ", location: "ಕರ್ನಾಟಕ" },
        { quote: "Helia ಬಳಸಿದ ನಂತರ 50% ಹೆಚ್ಚು ಹೂವು. ನನ್ನ ಮಾವಿನ ಮರಗಳು ಅತ್ಯುತ್ತಮವಾಗಿವೆ.", name: "ಸುಬ್ಬ ರೆಡ್ಡಿ", crop: "ಮಾವು ರೈತ", location: "ಆಂಧ್ರಪ್ರದೇಶ" }
      ]
    },
    footer: { description: "ಬಯೋಸ್ಟಿಮ್ಯುಲೆಂಟ್‌ಗಳು, ರಸಗೊಬ್ಬರಗಳು ಮತ್ತು ಸೂಕ್ಷ್ಮ ಪೋಷಕಗಳ ಪ್ರಮುಖ ತಯಾರಕ.", quickLinks: "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು", productCategories: "ಉತ್ಪನ್ನಗಳು", contactInfo: "ಸಂಪರ್ಕ ಮಾಹಿತಿ", followUs: "ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ", copyright: "2026 ಅವಂತ್ರ ಕೆಮಿಕಲ್ಸ್ ಪ್ರೈ ಲಿ. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.", tagline: "ಬೆಳೆ . ಸಮೃದ್ಧಿ . ಇಳುವೈ" },
    common: { learnMore: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ", submit: "ಸಲ್ಲಿಸಿ", loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...", success: "ಯಶಸ್ಸು!", error: "ಏನೋ ತಪ್ಪಾಗಿದೆ", search: "ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ..." }
  },
  hi: {
    nav: { home: "होम", about: "हमारे बारे में", products: "उत्पाद", dealers: "डीलर", contact: "संपर्क", careers: "करियर" },
    hero: {
      tagline: "खेती करने वाला रसायन विज्ञान",
      subtitle: "पूरे भारत में समृद्ध खेती के लिए नवीन बायोस्टिमुलेंट और उर्वरक",
      cta: "उत्पाद देखें",
      ctaSecondary: "और जानें"
    },
    aboutTeaser: {
      title: "कृषि नवाचार में अग्रणी",
      description: "2024 में स्थापित, अवंत्रा केमिकल्स फाइटोकोड तकनीक से भारतीय कृषि में क्रांति ला रहा है.",
      phytocode: "फाइटोकोड तकनीक"
    },
    phytocode: {
      title: "फाइटोकोड तकनीक",
      intro: "अवंत्रा केमिकल्स ने फाइटोकोड™ तकनीक का विकास किया है - एक अभूतपूर्व नवाचार जो एक ही उन्नत फॉर्मूलेशन में कई आवश्यक पोषक तत्वों को एकीकृत और स्थिर करता है.",
      benefit1Title: "पोषक तत्व समन्वय",
      benefit1Desc: "मैक्रोस, माइक्रोस और बायोस्टिमुलेंट्स को बिना क्षरण के एनकैप्सुलेट करता है, 2-3 गुना अधिक स्थिरता सुनिश्चित करता है.",
      benefit2Title: "दीर्घकालिक प्रभावकारिता",
      benefit2Desc: "फॉर्मूलेशन लंबे समय तक प्रभावी रहते हैं, उपयोग की आवृत्ति और अपशिष्ट को कम करते हैं.",
      benefit3Title: "पौधा-अनुकूलित रिलीज",
      benefit3Desc: "सेल्युलर स्तर पर धीरे-धीरे पोषक तत्व प्रदान करता है, लीचिंग को कम करता है, 20-30% अधिक अवशोषण.",
      howItWorksTitle: "यह कैसे काम करता है",
      howItWorksDesc: "फाइटोकोड नैनो-एनकैप्सुलेशन और बायो-मैट्रिक्स चीलेशन का उपयोग करके पोषक तत्वों को सुरक्षात्मक जाली में लॉक करता है। उपयोग के बाद, पौधे के एंजाइम समय पर रिलीज को ट्रिगर करते हैं।"
    },
    stats: { dealers: "डीलरशिप", farmers: "सेवित किसान", acres: "एकड़ कवर", licenses: "लाइसेंस उत्पाद", team: "टीम सदस्य", products: "उत्पाद श्रृंखला" },
    products: {
      title: "हमारे उत्पाद",
      subtitle: "बायोस्टिमुलेंट, उर्वरक और सूक्ष्म पोषक तत्वों की व्यापक श्रृंखला",
      all: "सभी", biostimulant: "बायोस्टिमुलेंट", biofertilizer: "जैव उर्वरक", liquid_fertilizer: "तरल उर्वरक", micronutrient: "सूक्ष्म पोषक", water_soluble: "जल में घुलनशील",
      viewProduct: "विवरण देखें", featured: "विशेष"
    },
    productDetail: { composition: "संरचना", howItWorks: "यह कैसे काम करता है", growthStages: "लक्षित वृद्धि चरण", dosage: "खुराक और उपयोग", advantages: "मुख्य लाभ", backToProducts: "उत्पादों पर वापस", component: "घटक", specification: "विनिर्देश" },
    about: {
      title: "अवंत्रा केमिकल्स के बारे में", subtitle: "भारतीय कृषि का भविष्य बनाने वाले युवा कृषि उद्यमी",
      mission: "मिशन", missionText: "उपज, गुणवत्ता और स्थिरता को अधिकतम करने वाले विश्व स्तरीय फसल पोषण समाधानों के साथ भारतीय किसानों को सशक्त बनाना.",
      vision: "विजन", visionText: "अत्याधुनिक शोध और खेत-स्तरीय प्रभाव के बीच की खाई को पाटना.",
      values: "हमारे मूल्य", valuesItems: ["विज्ञान से नवाचार", "किसान-प्रथम दृष्टिकोण", "गुणवत्ता में कोई समझौता नहीं", "टिकाऊ कृषि"],
      timeline: "हमारी यात्रा", team: "हमारी टीम", teamDesc: "मजबूत कृषि पृष्ठभूमि वाले युवा कृषि उद्यमियों के नेतृत्व में 18+ समर्पित सदस्य.",
      advisory: "सलाहकार बोर्ड", advisoryDesc: "प्रमुख संस्थानों के पूर्व वैज्ञानिक और प्रोफेसर.",
      advisoryMembers: ["ICAR दिल्ली पूर्व वैज्ञानिक", "IIHR बेंगलुरू प्रोफेसर", "GKVK मैसूर शिक्षक"],
      phytocodeTitle: "फाइटोकोड तकनीक", phytocodeDesc: "हमारी स्वामित्व तकनीक एक ही फॉर्मूलेशन में कई पोषक तत्वों को स्थिर करती है.",
      addresses: "हमारे स्थान", corporate: "कॉर्पोरेट कार्यालय", corporateAddr: "नं.5, RKM स्ट्रीट, हलसूरु, बेंगलुरू - 560068", factory: "फैक्ट्री", factoryAddr: "नं.375, लक्ष्मीपुरा, श्रीनिवासपुरा, कोलार - 563135"
    },
    dealers: { title: "डीलर नेटवर्क", subtitle: "कर्नाटक और आंध्र प्रदेश में 70+ डीलरशिप 12,000+ किसानों की सेवा", becomeDealer: "डीलर बनें", dealerForm: "अवंत्रा डीलर बनने के लिए आवेदन करें", name: "पूरा नाम", businessName: "व्यवसाय का नाम", email: "ईमेल", phone: "फोन", location: "स्थान / शहर", message: "आप अवंत्रा डीलर क्यों बनना चाहते हैं?", submit: "आवेदन जमा करें", mapTitle: "हमारी उपस्थिति", success: "आवेदन सफलतापूर्वक जमा हो गया!", states: "कर्नाटक और आंध्र प्रदेश में सक्रिय" },
    contact: { title: "हमसे संपर्क करें", subtitle: "पूछताछ, सहायता या साझेदारी के लिए हमारी टीम से संपर्क करें", name: "आपका नाम", email: "ईमेल पता", phone: "फोन नंबर", message: "आपका संदेश", submit: "संदेश भेजें", success: "संदेश सफलतापूर्वक भेजा गया!", info: "संपर्क जानकारी", corporate: "कॉर्पोरेट कार्यालय", factory: "फैक्ट्री" },
    testimonials: {
      title: "किसान क्या कहते हैं",
      items: [
        { quote: "अवंत्रा KMS से फल के आकार में अद्भुत सुधार। मेरी अनार की उपज 30% बढ़ी.", name: "आदिनारायण", crop: "अनार किसान", location: "आंध्र प्रदेश" },
        { quote: "Trumagic से मेरे तरबूज खेतों में सबसे अच्छे परिणाम। सूखे से तेजी से उबरे.", name: "प्रभाकर", crop: "तरबूज किसान", location: "कर्नाटक" },
        { quote: "Helia इस्तेमाल करने के बाद 50% ज्यादा फूल। मेरे आम के पेड़ इतने अच्छे कभी नहीं दिखे.", name: "सुब्बा रेड्डी", crop: "आम किसान", location: "आंध्र प्रदेश" }
      ]
    },
    footer: { description: "बायोस्टिमुलेंट, उर्वरक और सूक्ष्म पोषक तत्वों के प्रमुख निर्माता.", quickLinks: "त्वरित लिंक", productCategories: "उत्पाद", contactInfo: "संपर्क जानकारी", followUs: "हमें फॉलो करें", copyright: "2026 अवंत्रा केमिकल्स प्रा. लि. सर्वाधिकार सुरक्षित.", tagline: "बढ़ो . फलो . उपज" },
    common: { learnMore: "और जानें", submit: "जमा करें", loading: "लोड हो रहा है...", success: "सफलता!", error: "कुछ गलत हो गया", search: "उत्पाद खोजें..." }
  }
};
